<template>
  <div class="flex rounded-xl bg-light-2 p-5 shadow dark:bg-dark-2">
    <div v-if="icon" class="flex items-center pr-5">
      <em :class="`mdi mdi-${icon} text-3xl`"></em>
    </div>
    <slot></slot>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  icon?: string;
}>();
</script>
